import React from "react";
import { Box, Paper, Typography } from "@mui/material";
import { MD } from "./mdTheme";

/** Rank row: no horizontal scroll; label truncates; value stays visible */
const MdClientRankRow = ({
  label,
  value,
  barPct,
  color,
  onClick,
  wideValue = false,
}) => (
  <Paper
    elevation={0}
    onClick={onClick}
    role={onClick ? "button" : undefined}
    sx={{
      bgcolor: "#fff",
      border: `1px solid ${MD.line2}`,
      borderRadius: "6px",
      cursor: onClick ? "pointer" : "default",
      flex: "0 0 auto",
      overflow: "hidden",
      p: "6px 8px",
      width: "100%",
      "&:hover": onClick
        ? { bgcolor: MD.surface2, borderColor: MD.line }
        : undefined,
    }}
  >
    <Box
      sx={{
        display: "grid",
        gap: "3px 6px",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        minWidth: 0,
        width: "100%",
      }}
    >
      <Typography
        noWrap
        title={typeof label === "string" ? label : undefined}
        sx={{
          color: MD.fg,
          fontSize: 12,
          fontWeight: 600,
          minWidth: 0,
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {label || "—"}
      </Typography>
      <Typography
        noWrap
        component="div"
        sx={{
          color: MD.fg,
          flex: "none",
          fontFamily: MD.fontHead,
          fontSize: 12,
          fontVariantNumeric: "tabular-nums",
          fontWeight: 600,
          maxWidth: wideValue ? 120 : 88,
          overflow: "hidden",
          textAlign: "right",
          textOverflow: "ellipsis",
        }}
      >
        {value}
      </Typography>
      <Box
        sx={{
          bgcolor: MD.line2,
          borderRadius: 99,
          gridColumn: "1 / -1",
          height: 5,
          minWidth: 0,
          overflow: "hidden",
          width: "100%",
        }}
      >
        <Box
          sx={{
            bgcolor: color || MD.chart[0],
            borderRadius: 99,
            display: "block",
            height: "100%",
            maxWidth: "100%",
            minWidth: 4,
            width: `${Math.min(Math.max(Number(barPct) || 0, 2), 100)}%`,
          }}
        />
      </Box>
    </Box>
  </Paper>
);

export default MdClientRankRow;
